<template>
  <div class="home pr"   >
    <swiper class="swiper-Box" :options="swiperOption"   v-if="list.carousel.length>0"  >
    
      <swiper-slide class="swiper-slide" v-for="(item,index) in list.carousel" :key="index">
        <img
          class="swiper-img"
          :src="item.pic"
          v-if="height&&innerWidth>1024&&item.video==''"   :style="{'height':height}"
        />
        <img
          class="swiper-img"
          :src="item.phone_pic"
          v-else-if="height&&innerWidth<=1024&&item.video==''"   :style="{'height':height}"
        />
        <!-- https://dss0.bdstatic.com/-0U0bnSm1A5BphGlnYG/cae-legoup-video-target/ad06f462-fdac-4588-a19f-87190aecccca.mp4 -->
      
        <video class="swiper-img myvideo" v-if="item.video!=''"  :id="'video_' + index"    :style="{'height':height}" loop    muted  autoplay  :src="item.video" :poster="item.pic"  playsinline="true" webkit-playsinline="true"  preload="auto"></video>
       
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="bannerScroll"> -->
      
      <!-- </div> -->
      
    </swiper> 
    <div class="banner-l" :style="{'top':BtnHeight}" >
      <img src="../../../static/images/scroll-l.png" class="bannerLRImg" alt="">
    </div>
    <div class="banner-r" :style="{'top':BtnHeight}">
      <img src="../../../static/images/scroll-r.png" class="bannerLRImg" alt="">
    </div>
    <div class="overAllBox">
      <div class="home-box pr">
        <img src="../../../static/images/scroll-l.png"   v-if="innerWidth<=414" class="  scroll-l  "  alt="">
        <img src="../../../static/images/scroll-r.png" v-if="innerWidth<=414"  class="  scroll-r   "  alt="">
        <div class="home-title">{{list.title1}}</div>
        <div class="home-title-en">{{list.title_en1}}</div>
        <swiper class="swiper-Box" style="width:80%;margin: 0 auto" :options="swiperOption2" v-if="innerWidth<=414"  >
      <swiper-slide class="swiper-slide"  v-for="(item,index) in list.list1" :key="index">
          <div class="home-li" >
            <div class="home-li-div pr">
              <div class="home-li-hover masklayer " @click="toproducts(item.id)">
                <div class="home-li-hover-box animate__animated  animate__fadeInUp">
                  <div>VIEW MORE </div>
                  <img class="home-arrows" src="../../../static/images/arrows-right.png" alt />
                </div>
                <i></i>  
              </div>
              <img
                class="hover-img"
                :src="item.pic"
                alt
              />
            </div>

            <div>{{item.name}}</div>
          </div>
        </swiper-slide>
    </swiper>
        <div class="home-list " v-if="innerWidth>414" >
          <div class="home-li" v-for="(item,index) in list.list1" :key="index" >
            <div class="home-li-div pr">
              <div class="home-li-hover masklayer " @click="toproducts(item.id)">
                <div class="home-li-hover-box animate__animated  animate__fadeInUp">
                  <div>VIEW MORE</div>
                  <img class="home-arrows" src="../../../static/images/arrows-right.png" alt />
                </div>
                <i></i>  
              </div>
              <img
                class="hover-img"
                :src="item.pic"
                alt
              />
            </div>

            <div>{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="home-box" style="display: none;">
        <div class="home-title">{{list.title2}}</div>
        <div class="home-title-en">{{list.title_en2}}</div>
        <div class="home-list2">
          <div class="home-list-div hover2 pr"  v-if="list.box1">
            <div class="home-li-hover2" @click="toproductsXq(list.box1.id)">
              <div class="home-li-hover2-title" v-if="list.box1">{{list.box1.title}}</div>
              <div
                class="home-li-hover2-text"  v-if="list.box1"
              >{{list.box1.title_en}}</div>
              <div class="home-li-hover2-bottom animate__animated  animate__fadeInUp   ">
                <div>VIEW MORE</div>
                <img class="home-arrows" src="../../../static/images/arrows-right.png" alt />
              </div>
            </div>
            <img
              class="hover-img"
              :src="list.box1.pic"
              alt
            />
          </div>
          <div class="home-list-div">
            <div class="home-list-div-top">
              <div class="home-list-div-top-div hover2 pr"  v-if="list.box2">
                <div class="home-li-hover2" @click="toproductsXq(list.box2.id)">
                  <div class="home-li-hover2-title" v-if="list.box2">{{list.box2.title}}</div>
                  <div
                    class="home-li-hover2-text" v-if="list.box2">{{list.box2.title_en}}</div>
                  <div class="home-li-hover2-bottom animate__animated  animate__fadeInUp ">
                    <div>VIEW MORE</div>
                    <img class="home-arrows" src="../../../static/images/arrows-right.png" alt />
                  </div>
                </div>
                <img
                  class="hover-img"
                  :src="list.box2.pic"
                  alt
                />
              </div>
              <div class="home-list-div-top-div hover2 pr"  v-if="list.box3">
                <div class="home-li-hover2" @click="toproductsXq(list.box3.id)">
                  <div class="home-li-hover2-title" v-if="list.box3">{{list.box3.title}}</div>
                  <div
                    class="home-li-hover2-text"  v-if="list.box3"
                  >{{list.box3.title_en}}</div>
                  <div class="home-li-hover2-bottom animate__animated  animate__fadeInUp ">
                    <div>VIEW MORE</div>
                    <img class="home-arrows" src="../../../static/images/arrows-right.png" alt />
                  </div>
                </div>
                <img
                  class="hover-img"
                  :src="list.box3.pic"
                  alt
                />
              </div>
            </div>
            <div class="home-list-div-bottom hover2 pr"  v-if="list.box4">
              <div class="home-li-hover2" @click="toproductsXq(list.box4.id)">
                <div class="home-li-hover2-title" v-if="list.box4">{{list.box4.title}}</div>
                <div
                  class="home-li-hover2-text"  v-if="list.box4"
                >{{list.box4.title_en}}</div>
                <div class="home-li-hover2-bottom animate__animated  animate__fadeInUp ">
                  <div>VIEW MORE</div>
                  <img class="home-arrows" src="../../../static/images/arrows-right.png" alt />
                </div>
              </div>
              <img
                class="hover-img"
                :src="list.box4.pic"
                alt
              />
            </div>
          </div>
        </div>
        <div class="home-list-bottom pr"   v-if="list.box5">
          <div @click="toabouts()" class=" home-li-hover3  wow animate__animated animate__fadeInUpBig" data-wow-offset="10" data-wow-delay="2s" data-wow-iteration='infinite'>
            <div class="home-li-hover3-title" v-if="list.box5">{{list.box5.title}}</div>
            <div
              class="home-li-hover3-text"  v-if="list.box5"
            >{{list.box5.title_en}}</div>
            <div class="home-li-hover3-text2">{{list.box5.describe}}</div>
            <div class="home-li-hover3-bottom ">
              <div style="color:#ffffff;margin-right:2rem">VIEW MORE</div>
              <img class="home-arrows" src="../../../static/images/arrows-right.png" alt />
            </div>
          </div>
          <img
            class="home-list-bottom-img"
            :src="list.box5.pic"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import {WOW} from 'wowjs';
export default {
  name: "home",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      BtnHeight:'',
      height: '',//(window.innerHeight - 90)/10 + "rem"
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        // mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        // height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
        navigation: {
          nextEl: '.banner-r',
          prevEl: '.banner-l',
        },
        // initialSlide :1,
        updateOnImagesReady:true,
        loop: true,
        autoplay: true,
        autoplay: {
          delay:2000,
          disableOnInteraction: false,
        },
        speed:1500,
        on:{
          init: function(swiper){
            //Swiper初始化了
            //  播放
            var that=this
            setTimeout(function(){
               let index = this.activeIndex;
                let vList = document.querySelectorAll(".myvideo");
                for(var i=0;i<vList.length;i++){
                  if(i>1){
                    vList[i].muted = true;//静音
                   vList[i].pause();
                  }
                  
                }
              if($(".swiper-slide-active" ).children( "video" ).length>0){
                let videoin='.swiper-slide-active video';
                var audio =$(videoin);
                var au=audio[0];
                au.play();
                that.autoplay.stop();
                au.loop = false // 不设置视频循环播放
                // au.muted = false;//当前视频取消静音
                au.addEventListener('ended', () => { //该视频播放是否已结束
                that.autoplay.start();
                }, false)
              }
           },1500)
            
          }, 
          // 轮播切换后，上一个swiper-slie有视频，则暂停
          slideNextTransitionStart:function(){ //向后切换
            let index = this.activeIndex;
            let vList = document.querySelectorAll(".myvideo");
            for(var i=0;i<vList.length;i++){
              //  vList[i].muted = true;//静音
               vList[i].pause();
            }
            //  播放
            if($(".swiper-slide-active" ).children( "video" ).length>0){
          
              let videoin='.swiper-slide-active video';
              var audio =$(videoin);
              var au=audio[0];
              au.play();
           
              this.autoplay.stop();
              au.loop = false // 不设置视频循环播放
              // au.muted = false;//当前视频取消静音
              au.addEventListener('ended', () => { //该视频播放是否已结束
               this.autoplay.start();
              }, false)
            }
            
          },
          slidePrevTransitionStart:function(){ //向前切换
            let index = this.activeIndex;
            let vList = document.querySelectorAll(".myvideo");
            for(var i=0;i<vList.length;i++){

               vList[i].muted = true;//静音
              vList[i].pause();
            }
            //  播放
            if($(".swiper-slide-active" ).children( "video" ).length>0){
              let videoin='.swiper-slide-active video';
              var audio =$(videoin);
              var au=audio[0];
              au.play();
              this.autoplay.stop();
              au.loop = false // 不设置视频循环播放
              // au.muted = false;//当前视频取消静音
              au.addEventListener('ended', () => { //该视频播放是否已结束
               this.autoplay.start();
              }, false)
            }
          },
         
        
        }
      },
      liheight:'auto',
      swiperOption2: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        // autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        // mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        loop: true,
        speed:1000,
        navigation: {
          nextEl: '.scroll-r',
          prevEl: '.scroll-l',
        },
       
      },
      innerWidth:window.innerWidth,
      list:[],
      divnum:0,
      scrollBottom:'',
      isScroll:0,
      isUpDown:true,
      // muted:''
    }
  },
   
  props:[
     'muted'
  ],
  watch: {
    muted(newName, oldName) { //静音变量
       if(newName==true){//当前视频静音
          let vList = document.querySelectorAll(".myvideo");
            for(var i=0;i<vList.length;i++){
              vList[i].muted = true;
            }
       }else{
            let videoin='.swiper-slide-active video';
              var audio =$(videoin);
              var au=audio[0];
             au.muted = false;//当前视频取消静音
       }
    }
  },
  created(){
    this.index();
  },
  mounted(){
   var wow = new WOW(); 
    wow.init(); 
    let inwidth=window.innerWidth
    this.innerWidth=window.innerWidth;
    var getScreenHeight = function() {
      return document.documentElement ? document.documentElement.clientHeight : window.innerHeight;
    };


    if(inwidth<=1024){
      // this.height='auto'
      this.BtnHeight=(getScreenHeight() -50)/2+'px';
      this.height=(getScreenHeight() -50)+'px';
    }else{//pc端
    this.BtnHeight=(getScreenHeight()  - $('.header').height())/2 + "px" ;
      // this.height=(getScreenHeight()  - $('.header').height()) + "px" 
      this.height='90vh' 
    }
     window.addEventListener('scroll', this.onScroll)

  },
  methods:{
     onScroll(){
       let that=this
      let divtop=$(".home-li-hover3 ").offset().top-$(document).scrollTop()
      //  $('.myvideo').prop('muted', false);
      if($(window).scrollTop() > 900){
        
          $(".home-li-hover3 ").show()
        
      }else{
         $(".home-li-hover3 ").hide()
      }
       // 页面滚动距顶部距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let scroll = scrollTop - that.isScroll;
      that.isScroll = scrollTop;
       var getScreenHeight = function() {
          return document.documentElement ? document.documentElement.clientHeight : window.innerHeight;
        };
      if(scroll<0){
      //  console.log(that.isUpDown)
         if(scrollTop<getScreenHeight()-120&&that.isUpDown==true){
            that.isUpDown=false
            $('html,body').animate({scrollTop:0},1000)
            
            setTimeout(function(){
                that.isUpDown=true
            },1000)
         }
      }else if(scroll>1){
          if(scrollTop<getScreenHeight()-120&&that.isUpDown==true){
            that.isUpDown=false
            $('html,body').animate({scrollTop:getScreenHeight()-100},1000)
            setTimeout(function(){
              that.isUpDown=true
            },1000)
          }
          
      }
     },
     //首页接口
    index() {
      var that = this;
      let data = {};
      that.$api.index(data).then(res => {
        if (res.status == 1) {
           that.list=res.data
           
          
        } else {
          that.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    toproducts(id){
      this.$router.push({ name: 'products', query: {cate_id:id} });
    },
    toproductsXq(id){
      this.$router.push({ path:'/solutionsDetail', query:{soluid:id} });
    },
    toabouts(){
      this.$router.push({ name: 'about', query: {} });
    }

  },
  beforeDestroy() {//清除监听
        window.removeEventListener('scroll', this.onScroll)
  },
};
</script>
<style  >
.swiper-Box{
  position: relative;
}
.bannerLRImg{
  width: 90%;
}
.banner-l,.banner-r{
  width: 8rem;
  height: 8rem;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 1rem;
  z-index: 999;
  top:30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: -4rem;
}
.banner-l:focus{
  outline: none;
}
.banner-r:focus{
  outline: none;
}
.banner-l{
  position: absolute;
  left: 0;
}
.banner-r{
  position: absolute;
  right: 0;
}
.scroll-l,.scroll-r{
  position: absolute;
  width:5rem;
  height: 5rem;
  top: 60%;
  outline: none;
}
.scroll-l{
  left: -2rem;
  z-index: 1999;
}
.scroll-r{
  right: -2rem;
  z-index: 1999;
}
.swiper-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #a2a3a5;
  opacity: 1;
}
.home .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #ffffff;
}
.home-box {
  padding-top: 4.5rem;
  text-align: center;
}
.home-title {
  font-size: 3.6rem;
  text-align: center;
  font-weight: bold;
  color: #4c4c4c;
  margin-bottom: 1.5rem;
  letter-spacing:0.2rem;
}
.home-title-en {
  font-size: 1.6rem;
  color: #999999;
  margin-bottom: 4.5rem;
}
.home-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /* margin-bottom: 5.5rem; */
  margin-bottom: 2rem;
  transition: all 1s;
}
.home-li {
  /* width: 22%; */
  width: 28.4rem;
  /* height:36rem; */
  text-align: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  /* margin-right: 4%; */
  margin-right: 2rem;
}
.home-li:last-child {
  margin-right: 0;
}
.home-li-div {
  width: 100%;
  height: 36rem;
  margin-bottom: 1.8rem;
  overflow: hidden;
}
.home-li-div > img {
  width: 100%;
  height: 100%;
  
}
.home-li-hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 1.8rem;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.0);
  opacity: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  cursor: pointer;
  transition: all 1s;
}
.home-li-hover .home-arrows {
  margin-top: 2rem;
}
.home-li-hover2 .home-arrows {
  margin-left: 2rem;
  width: 1.4rem;
  height: 1rem;
  margin-top: 0.1rem;
}
.home-arrows {
  width: 1.4rem;
  height: 1rem;
}
.hover-img{
  transition: all 1s;  
}


.home-li-hover-box{
  display: none;
  /* margin-top: 6rem; */
 
}

 
.home-list2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.home-list2 img {
  width: 100%;
  height: 100%;
}
.home-list-div {
  /* width: 49%; */
  width: 58.9rem;
  height: 58rem;
  overflow: hidden;
}
.home-list-div-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.home-list-div-top-div {
  /* width: 48%; */
  width: 28.6rem;
  height: 28.6rem;
  overflow: hidden;
}

.home-list-div-bottom {
  /* width: 100%; */
  width: 59.1rem;
  height: 28.5rem;
  margin-top: 2rem;
  overflow: hidden;
}

.home-list-bottom {
  width: 100%;
  height: 37rem;
  margin: 5rem 0;
   overflow: hidden;
}
.home-list-bottom > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hover2{
    cursor: pointer;
}
.home-li-hover2{
  position: absolute;
  bottom: -50%;
  left: 3%;
  width: 94%;
  height: 14.2rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  opacity: 0;
  transition: all .4s cubic-bezier(0.455,.03,.515,.955)
}
.home .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
  bottom: 5.2rem;
}
.home .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction{
  /* bottom: 5.2rem;  */
  bottom:6.6%;
}
.hover2 .hover-img{
    transition: all .7s; 
}

.home-li-hover2-title {
  font-size: 1.8rem;
}
.home-li-hover2-text {
  font-size: 1.4rem;
  margin: 1.5rem 2rem 2rem 2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display:-webkit-box; 
  -webkit-box-orient:vertical; 
  -webkit-line-clamp:2; 
}
.home-li-hover2-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #eeeeee;
  font-size: 1.2rem;
  display: none;
  margin-top:-2rem;
  transition: all .4s; 
  animation-delay:0.2s;
}
video::-webkit-media-controls-timeline {
      display: none;
  }

.home-li-hover3-bottom {
  display: flex;
  align-items: center;
  justify-content: center;

}

.home-li-hover3 {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  opacity: 1;
  /* transition: all 1s;   */
}
/* .home-li-hover3:hover {
  opacity: 1;
} */
.home-li-hover3-title {
  font-weight: bolder;
  font-size: 3.6rem;
  padding-top: 7.6rem;
  margin-bottom: 3.6rem;
}
.home-li-hover3-text {
  font-size: 1.6rem;
  margin-bottom: 1.8rem;
}
.home-li-hover3-text2 {
  font-size: 1.6rem;
  margin-bottom: 9rem;
}


.home-li-hover i {
  position: absolute;
  width: 200%;
  height: 100%;
  top: 0;
  left: -250%;
  background-color: rgba(0, 0, 0, 0.5);
  -moz-transform: skewX(30deg);
  -o-transform: skewX(30deg);
  -ms-transform: skewX(30deg);
  -webkit-transform: skewX(30deg);
  transform: skewX(30deg);
  -webkit-transition: all 0.6s ease-in-out;
  -moz-transition: all 0.6s ease-in-out;
  -o-transition: all 0.6s ease-in-out;
  transition: all 0.6s ease-in-out;
  z-index: 998;
}
/* #index .product .swiper .swiper-slide:hover .masklayer .texts .name p,
#index .product .swiper .swiper-slide:hover .masklayer .texts .desc p,
#index .product .swiper .swiper-slide:hover .masklayer .texts .icon img {
  display: block;
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
} */

.home-list-bottom-img{
  transition: all 1s; 
}
.home-list-bottom div{
  z-index: 999;
}
.home-list-bottom .home-arrows{
  transition: all 1s;
}

 
@media screen and (min-width:1200px) and (max-width:3200px){
    .home-li:hover .hover-img {
      transform: scale(1.2);
    }
    .home-li:hover .home-li-hover{
        left: 0;
        top: 0;
        opacity: 1;
        z-index: 99;
        
    }
    .home-li:hover .home-li-hover-box{
        /* margin-top: 0rem; */
      display: block;
      z-index: 999;
      
    }
 
    .hover2:hover .home-li-hover2{
      bottom: 0;
      opacity: 1;
      z-index: 99;
    }
    .hover2:hover .hover-img {
      transform: scale(1.2);
    }
    .hover2:hover .home-li-hover2-bottom{
      display: flex;
      margin: 0rem;
    }

    .home-li-hover:hover  i {
      left: -50%;
    }
    .home-list-bottom:hover .home-arrows{
      margin-right: -2rem;
    }
    .home-list-bottom:hover .home-list-bottom-img {
      transform: scale(1.2);
    }
}

/*当浏览器尺寸1024时候的代码：*/
@media  screen  and (max-width: 1200px){

    .home-li-hover2,.home-li-hover3{
      font-size: 1.8rem;
    }
    .home-li-hover{
      left: 0;
      top: 0;
      opacity: 1;
      font-size: 1.8rem;
      background-color: rgba(0, 0, 0, 0.0);
    }
  
    .home-list{
      margin-right: 0;
    }
    .home-li{
      width: 44%;
      /* margin-right: 6%; */
      margin: 0 3%;
      margin-bottom: 1.8rem;
     
    }
    .home-li:nth-child(even){
      margin-right:0;
    }
    .home-li-div{
      height: auto;
    }
    .home-list2{
      flex-wrap: wrap;
    }
    .home-list-div{
      width: 100%;
      margin-bottom: 2rem;
    }
   
    .home-list-div-top-div{
      width: 49%;
    }
    .home-list-div-bottom{
      width: 100%;
    }

    
}

/*当浏览器尺寸768px时候的代码：*/
@media screen and  (max-width: 1024px){
    .home-li-hover2,.home-li-hover3{
      opacity: 1;
      bottom: 0;
    }
    .home-li-hover{
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.0);
    }
    .home-li-hover-Box{
      margin-top: 0;
      opacity: 1;
    }
    .home-list{
      margin-right: 0;
    }
    .home-li{
      width: 44%;
      /* margin-right: 6%; */
      margin: 0 3%;
      margin-bottom: 1.8rem;
     
    }
    .home-li:nth-child(even){
      margin-right:0;
    }
    .home-list2{
      flex-wrap: wrap;
    }
    .home-list-div{
      width: 100%;
      margin-bottom: 2rem;
    }
    .home-li-hover2-bottom{
      display: flex;
      margin-top: 1rem;
    }
}
/*当浏览器尺寸小于768px时候的代码：手机端 */ 
@media screen and (max-width:768px){
 
}
 /*当浏览器尺寸小于414px时候的代码：手机端 */ 
@media screen and (max-width:414px){
   
    .home-list{
      width: 100%;
      display: -webkit-box;
      flex-wrap: nowrap;
      overflow-x: scroll;
      margin-bottom: 0;
    }
    .home-list::-webkit-scrollbar{
        display: none;
    }
    .home-li{
      width: 100%;
      margin-right: 0rem;
      margin-bottom: 0;
      margin: 0;
    }
    .home-li:nth-child(even) {
      margin-right: 0;
    }
    .home-li-div {
      width: 100%;
      margin: 0 auto;
      margin-bottom: 2rem;
    }

    .home-li-hover2,.home-li-hover3{
      opacity: 1;
      bottom: 0;  
      font-size: 1.8rem;    
    }
    .home-li-hover{
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.0);
    }
    .home-li-hover-Box{
      margin-top: 0;
      opacity: 1;
    }
    .home-li-hover2-text{
      margin: 1.0rem 2rem 1.5rem 2rem;
    }
    .home-list2{
      flex-wrap: wrap;
    }
    .home-list-div{
      width: 100%;
      height: auto;
      margin-bottom: 2rem;
    }
    .home-list-div-top{
      flex-wrap: wrap;
    }
    .home-li-div{
      height: auto;
    }
    .home-list-div-top-div{
      width: 100%;
      height: auto;
      margin-bottom: 2rem;
    }
    .home-list-bottom{
      height: 25rem;
      margin-top: 2rem;
    
    }
    .home-li-hover3-title{
      padding-top: 3rem;
      margin-bottom: 1.6rem;
    }
    .home-li-hover3-text2{
      margin-bottom: 2rem;
    }
    
    .home-li-hover3-text2{
      font-size: 1.4rem;
    }

    .home-list-div-bottom{
      width: 100%;
    }
   .home-li-hover2-bottom{
    display: flex;
    margin-top: 1rem;
  }
    .home-li:nth-child(even){
      margin-right:2rem;
    }
}
/*当浏览器尺寸小于320px时候的代码：手机端 */ 
@media screen and (max-width:320px){
    .home-li-hover3-title{
      margin-top: -1rem;
      margin-bottom: 1.5rem;
    }
    .home-li-hover2-bottom{
    display: flex;
    margin-top: 1rem;
  }
}
 
</style>